import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "schedule-days" }
const _hoisted_2 = ["onSubmit"]

import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import TimeToolbar from '@/components/toolbar/TimeToolbar.vue';
import ScheduleDay from './ScheduleDay.vue';
import { addDays, format } from 'date-fns';
import { Schedule } from '@/models/schedule.model';
import { Actions } from '@/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'ScheduleDays',
  setup(__props) {

const store = useStore();
const router = useRouter();

const schedule = computed<Schedule>(() => store.state.schedule);
const date = computed<string>(() => store.state.date);

const previous = async () => {
  let d = new Date(date.value);
  d = addDays(d, -7);
  router.push(`/schedule/${format(d, 'yyyy-MM-dd')}`);
};
const next = async () => {
  let d = new Date(date.value);
  d = addDays(d, 7);
  router.push(`/schedule/${format(d, 'yyyy-MM-dd')}`);
};
const submit = async () => {
  await store.dispatch(Actions.UpdateSchedule, {
    item: schedule.value,
    edit: true,
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(TimeToolbar, {
      title: `Week ${_unref(schedule).weekNumber}`,
      onPrevious: previous,
      onNext: next
    }, null, 8, ["title"]),
    _createElementVNode("form", {
      onSubmit: _withModifiers(submit, ["prevent"])
    }, [
      _createElementVNode("ul", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(schedule).schedule, (day) => {
          return (_openBlock(), _createBlock(ScheduleDay, {
            key: day.date,
            day: day,
            onUpdate: submit
          }, null, 8, ["day"]))
        }), 128))
      ])
    ], 40, _hoisted_2)
  ]))
}
}

})